import React, { useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { ANALYTICS_CONSENT_KEY } from './analytics';

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(() => {
    try { return window.localStorage.getItem(ANALYTICS_CONSENT_KEY); } catch (_) { return 'declined'; }
  });
  const [visible, setVisible] = useState(() => choice === null);

  useEffect(() => {
    const openSettings = () => setVisible(true);
    window.addEventListener('makemyresume-open-analytics-settings', openSettings);
    return () => window.removeEventListener('makemyresume-open-analytics-settings', openSettings);
  }, []);

  const saveChoice = (nextChoice) => {
    try { window.localStorage.setItem(ANALYTICS_CONSENT_KEY, nextChoice); } catch (_) {}
    setChoice(nextChoice);
    setVisible(false);
  };

  return (
    <>
      {choice === 'accepted' && (
        <Analytics beforeSend={(event) => {
          try {
            const url = new URL(event.url, window.location.origin);
            if (url.searchParams.has('session_id')) return null;
            url.search = '';
            return { ...event, url: url.toString() };
          } catch (_) { return event; }
        }} />
      )}
      {visible && (
        <aside className="analytics-consent" role="dialog" aria-label="Optional analytics settings" aria-live="polite">
          <div className="analytics-consent-title">Help us improve MakeMyResume</div>
          <p className="analytics-consent-copy">Optional, cookie-free analytics help us improve the site. We never collect your CV content or account details. Change your choice anytime in the Privacy Policy.</p>
          <div className="analytics-consent-actions">
            <button className="analytics-consent-allow" onClick={() => saveChoice('accepted')}>Allow optional analytics</button>
            <button className="analytics-consent-decline" onClick={() => saveChoice('declined')}>Decline</button>
          </div>
        </aside>
      )}
    </>
  );
}
